<template><div><h1>VUX V2.1.0Rc.47 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[enhance] 修复内容多时的箭头位置 #715 @greedying </li>
</ul>
<h2><a href="/zh-CN/components/qrcode.html">Qrcode</a></h2>
<ul><li>[feature] 支持渲染类型为图片 #900 @keepgoingwm</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[enhance] 删除无用代码</li>
<li>[fix] 修复`取消`按钮在非`fixed`情况下没有出现的问题 @excitedcat</li>
<li>[fix] 修复页面上多个实例时，`label id`冲突</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.47 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.47-203.vue?52d10116